import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Dashboard from "./Pages/Dashboard";
import PrivateRoutes from "./utils/ProtectedRoutes";
import Wrapper from "./Component/Wrapper";
import Login from "./Pages/Login";
import LoginCheckRoute from "./utils/LoginCheckRoute";
import "./assets/css/rome.css";
import "./assets/css/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./Pages/Home";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-datepicker/dist/react-datepicker.css";
import AwarnessList from "./Pages/Assignment/AwarnessList";
import ElibraryList from "./Pages/ELibrary/Listing";
import CreateAssignment from "./Pages/Assignment/CreateAssignemnt";
// import AccountActivationList from "./Pages/AccountActivation/Listing";
import Questions from "./Pages/Questions";
import AddForm from "./Pages/ELibrary/AddForm";
import { LocalizationProvider } from "./Component/Localization/Localization";
import AddQuestions from "./Pages/ELibrary/AddQuestion";
import QuestionReview from "./Pages/QuestionReview";
import QuestionEvaulate from "./Pages/QuestionEvaulate";
import { useEffect, useState } from "react";
function App() {
  const [isBlurred, setIsBlurred] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "PrintScreen") {
        setIsBlurred(true);
        setTimeout(() => {
          setIsBlurred(false);
        }, 1000);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  return (
    <div style={{ filter: !isBlurred ? "none" : "blur(8px)" }}>
      <LocalizationProvider>
        <BrowserRouter basename="/nurse">
          <ToastContainer />

          <Routes>
            <Route element={<PrivateRoutes />}>
              <Route element={<Wrapper />}>
                {/* <Route element={<PrivateRoutes />}> */}
                <Route path={`/dashboard`} element={<Dashboard />} />

                <Route
                  path={`/Assignment/:assessmentType`}
                  element={<AwarnessList />}
                />

                <Route
                  path={`/elibrary/:assessmentType`}
                  element={<ElibraryList />}
                />
                {/* <Route
                  path={`/AccountActivationList`}
                  element={<AccountActivationList />}
                /> */}

                <Route
                  path={`/CreateAssignment/:assessmentType`}
                  element={<CreateAssignment />}
                />

                <Route
                  path={`/elibary/:assessmentType`}
                  element={<AddForm />}
                />
                <Route
                  path={`/elibary/:assessmentType/:id`}
                  element={<AddForm />}
                />
                <Route
                  path={`/addquestion/:assessmentType/:assignment`}
                  element={<AddQuestions />}
                />

                <Route
                  path={`/addquestion/:assessmentType/:assignment/:value`}
                  element={<AddQuestions />}
                />

                <Route
                  path={`/questions/review/:assignment`}
                  element={<QuestionReview />}
                />
                <Route
                  path={`/questions/review/:assignment/:id`}
                  element={<QuestionReview />}
                />

                <Route
                  path={`/questions/evaluate/:assignment/:id`}
                  element={<QuestionEvaulate />}
                />
                <Route
                  path={`/questions/:assignment/:id`}
                  element={<Questions />}
                />
                <Route
                  path={`/questions/:assignment`}
                  element={<Questions />}
                />
              </Route>
            </Route>

            <Route element={<LoginCheckRoute />}>
              <Route path={`/login`} element={<Login />} />

              {/* <Route path={`/`} element={<Home />} /> */}
            </Route>
            <Route path={`*`} element={<Login />} />

            {/* <Route path={`/`} element={<Home />} /> */}
          </Routes>
        </BrowserRouter>
      </LocalizationProvider>
    </div>
  );
}

export default App;
